import {
  Home,
  Package,
  Tag,
  Ban,
  Wallet,
  Store,
  BarChart3,
  ShoppingCart,
  Star,
  Settings,
  Car,
  Image,
  Utensils,
  Gift,
  Boxes,
  Ticket,
  Layers,
  PersonStanding,
  Medal,
  UserCog,
  Users,
  UserSquare,
  Cog,
  Contact,
  Newspaper,
  PoundSterlingIcon,
  Award,
  Key,
  Bell,
  Plus,
  Share2,
  LayoutDashboard,
  Network,
  CalendarDays,
  CalendarRange,
  Waves,
  Heart,
  Activity,
  Building2,
  DollarSign,
  FileText,
} from "lucide-react";
import { PermissionsKey } from "./permissions";
import { sidebarLink } from "../types/sidebarLink";

export const adminSidebarLinks = [
  {
    title: "admin_sidebar.home",
    href: "/admin",
    icon: Home,
  },
  {
    title: "admin_sidebar.contracts",
    href: "/admin/contracts",
    icon: FileText,
    permission: PermissionsKey.ManageContract,
  },

  {
    title: "admin_sidebar.integrations",
    icon: Network,
    permission: PermissionsKey.SyncIntegrations,
    children: [
      {
        title: "admin_sidebar.foodics",
        href: "/admin/foodics",
        icon: Network,
        permission: PermissionsKey.SyncIntegrations,
      },
      {
        title: "admin_sidebar.blend",
        href: "/admin/blend",
        icon: Network,
        permission: PermissionsKey.SyncIntegrations,
      },
      {
        title: "admin_sidebar.foodizone",
        href: "/admin/foodizone",
        icon: Network,
        permission: PermissionsKey.SyncIntegrations,
      },
      {
        title: "admin_sidebar.deliverect",
        href: "/admin/deliverect",
        icon: Network,
        permission: PermissionsKey.SyncIntegrations,
      }
    ]
  },

  // Activities Group
  {
    title: "admin_sidebar.activities",
    icon: Activity,
    permission: PermissionsKey.ViewStoreOrders,
    children: [
      {
        title: "admin_sidebar.orders",
        href: "/admin/orders",
        icon: ShoppingCart,
        permission: PermissionsKey.ViewStoreOrders,
      },
      {
        title: "admin_sidebar.cart",
        href: "/admin/cart",
        icon: ShoppingCart,
        permission: PermissionsKey.ViewCart,
      },
      {
        title: "admin_sidebar.bookings",
        href: "/admin/bookings",
        icon: CalendarRange,
        permission: PermissionsKey.ViewStoreOrders,
      },
      {
        title: "admin_sidebar.laundry_orders",
        href: "/admin/laundry",
        icon: Waves,
        permission: PermissionsKey.ManageLaundryOrder,
      },
      {
        title: "admin_sidebar.donations",
        href: "/admin/donations",
        icon: Heart,
        permission: PermissionsKey.ViewCustomer,
      },
      {
        title: "admin_sidebar.customer_reviews",
        href: "/admin/customer-reviews",
        icon: Star,
        permission: PermissionsKey.ViewStoreReviews,
      },
      {
        title: "product_price_approval.title",
        href: "/admin/product-price-approval",
        icon: DollarSign,
        permission: PermissionsKey.UpdateProduct,
      },
    ]
  },

  {
    title: "admin_sidebar.tickets",
    icon: Ticket,
    permission: PermissionsKey.ManageTickets,
    children: [
      {
        title: "admin_sidebar.ticket_types",
        href: "/admin/tickets",
        icon: Ticket,
        permission: PermissionsKey.ManageTickets,
      },
      {
        title: "admin_sidebar.support_tickets",
        href: "/admin/support-tickets",
        icon: Ticket,
        permission: PermissionsKey.ManageTickets,
      },
    ],
  },
  {
    title: "admin_sidebar.loyalty",
    icon: Award,
    children: [
      {
        title: "admin_sidebar.offers",
        href: "/admin/offers",
        icon: Gift,
        permission: PermissionsKey.ViewOffer,
      },
      {
        title: "admin_sidebar.loyalty_offers",
        href: "/admin/wallet",
        icon: Star,
        permission: PermissionsKey.ViewLoyaltyOffer,
      },
      {
        title: "admin_sidebar.coupouns",
        href: "/admin/coupouns",
        icon: Ticket,
        permission: PermissionsKey.ViewCoupon,
      },
      {
        title: "admin_sidebar.streaks",
        href: "/admin/streaks",
        icon: Award,
        permission: PermissionsKey.ManageStreak,
      },
      {
        title: "admin_sidebar.wallet_transactions",
        href: "/admin/wallet-top-up-transactions",
        icon: Wallet,
        permission: PermissionsKey.ViewCustomerTransactions,
      },
      {
        title: "admin_sidebar.customer_bonuses",
        href: "/admin/customer-bonuses",
        icon: Gift,
        permission: PermissionsKey.ViewCustomerLoyaltyActivities,
      },
      {
        title: "admin_sidebar.customer_rewards",
        href: "/admin/customer-rewards",
        icon: Gift,
        permission: PermissionsKey.ViewCustomerLoyaltyActivities,
      },
      {
        title: "admin_sidebar.gifts",
        href: "/admin/gifts",
        icon: Gift,
        permission: PermissionsKey.ViewCustomerGifts,
      },
    ],
  },
  {
    title: "admin_sidebar.home_page",
    icon: LayoutDashboard,
    permission: PermissionsKey.ManageSyestemEntities,
    children: [
      {
        title: "admin_sidebar.store_type",
        href: "/admin/store-types",
        icon: Tag,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.custom_app",
        href: "/admin/custom-app",
        icon: LayoutDashboard,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.offer_banners",
        href: "/admin/offer-banners",
        icon: Image,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.top_brands",
        href: "/admin/top-brands",
        icon: Star,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.prize_wheel",
        href: "/admin/prize-wheel",
        icon: Award,
        permission: PermissionsKey.ManagePrizeWheel,
      },
      {
        title: "admin_sidebar.prize_wheel_spins",
        href: "/admin/prize-wheel/spins",
        icon: Award,
        permission: PermissionsKey.ManagePrizeWheel,
      },
      {
        title: "admin_sidebar.notification_templates",
        href: "/admin/notification-templates",
        icon: Bell,
        permission: PermissionsKey.ManageNotificationTemplates,
      },
    ],
  },
  {
    title: "admin_sidebar.catalog",
    icon: Boxes,
    children: [
      {
        title: "admin_sidebar.car_brand",
        href: "/admin/car-brands",
        icon: Car,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.cancel_reasons",
        href: "/admin/cancel-reasons",
        icon: Ban,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.avatars",
        href: "/admin/avatars",
        icon: Image,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.sectors",
        href: "/admin/sectors",
        icon: Utensils,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.gift_catgeories",
        href: "/admin/gift-categories",
        icon: Gift,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.variant_categories",
        href: "/admin/variant-categories",
        icon: Boxes,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.store_suggestions",
        href: "/admin/store-suggestions",
        icon: Store,
        permission: PermissionsKey.ManageSyestemEntities,
      },
    ],
  },

  // Users & Entities Group
  {
    title: "admin_sidebar.users_entities",
    icon: Building2,
    children: [
      {
        title: "admin_sidebar.owners",
        href: "/admin/owners",
        icon: PersonStanding,
        permission: PermissionsKey.ViewOwners,
      },
      {
        title: "admin_sidebar.customers",
        href: "/admin/customers",
        icon: UserSquare,
        permission: PermissionsKey.ViewCustomer,
      },
      {
        title: "admin_sidebar.organizations",
        href: "/admin/organizations",
        icon: Users,
        permission: PermissionsKey.ManageOrganization,
      },
      {
        title: "admin_sidebar.merchant_registrations",
        href: "/admin/merchant-registrations",
        icon: Building2,
        permission: PermissionsKey.ManageMerchantRegistration,
      },
      {
        title: "owner_sidebar.stores",
        href: "/admin/stores",
        icon: Store,
        permission: PermissionsKey.ViewStores,
      },
    ]
  },

  {
    title: "admin_sidebar.employees_management",
    icon: Cog,
    children: [
      {
        title: "admin_sidebar.roles",
        href: "/admin/roles",
        icon: UserCog,
        permission: PermissionsKey.viewRole,
      },
      {
        title: "admin_sidebar.employees",
        href: "/admin/employees",
        icon: Users,
        permission: PermissionsKey.ViewAdmin,
      },
    ],
  },
  {
    title: "admin_sidebar.system_settings",
    icon: Cog,
    children: [
      {
        title: "admin_sidebar.points",
        href: "/admin/points",
        icon: Medal,
        permission: PermissionsKey.SystemPoints,
      },
      {
        title: "admin_sidebar.contact_settings",
        href: "/admin/contact-info",
        icon: Contact,
        permission: PermissionsKey.SystemSettings,
      },
      {
        title: "admin_sidebar.view_social_links",
        href: "/admin/social-links",
        icon: Share2,
        permission: PermissionsKey.ManageSyestemEntities,
      },
      {
        title: "admin_sidebar.site_content",
        href: "/admin/site-content",
        icon: Newspaper,
        permission: PermissionsKey.LandingPage,
      },
      {
        title: "admin_sidebar.referral_system",
        href: "/admin/rewards-system",
        icon: Award,
        permission: PermissionsKey.SystemPoints,
      },
    ],
  },
  {
    title: "rewards",
    icon: Award,
    children: [
      {
        title: "admin_sidebar.created_account_pouns",
        href: "/admin/signup-rewards",
        icon: PoundSterlingIcon,
        permission: PermissionsKey.ViewCustomerLoyaltyActivities,
      },
      {
        title: "admin_sidebar.accepted_invites_rewards",
        href: "/admin/accepted-invites",
        icon: Gift,
        permission: PermissionsKey.ViewCustomerLoyaltyActivities,
      },
    ],
  },
  {
    title: "admin_sidebar.message_service",
    href: "/admin/otp-service",
    icon: Key,
    permission: PermissionsKey.ViewOtpHistory,
  },
  {
    title: "admin_sidebar.notifications",
    icon: Bell,
    children: [
      {
        title: "admin_sidebar.add_notification",
        href: "/admin/add-notification",
        icon: Plus,
        permission: PermissionsKey.SendNotifications,
      },
      {
        title: "admin_sidebar.notification_history",
        href: "/admin/notifications",
        icon: Bell,
        permission: PermissionsKey.SendNotifications,
      },
      {
        title: "admin_sidebar.send_sms",
        href: "/admin/send-sms",
        icon: Bell,
        permission: PermissionsKey.SendNotifications,
      },
    ],
  },
  {
    title: "admin_sidebar.partners",
    href: "/admin/partners",
    icon: Network,
    permission: PermissionsKey.ManageSyestemEntities,
  },
  {
    title: "admin_sidebar.events",
    icon: CalendarDays,
    children: [
      {
        title: "admin_sidebar.organizers",
        href: "/admin/organizers",
        icon: Plus,
        permission: PermissionsKey.ViewOrganizer,
      },
      {
        title: "admin_sidebar.events",
        href: "/admin/events",
        icon: CalendarRange,
        permission: PermissionsKey.ViewEvent,
      },
    ],
  },
];

// owner sidebar links

export const storeSidebarLinks = [
  {
    title: "owner_sidebar.store_dashboard",
    href: "/store/dashboard",
    icon: BarChart3,
  },
  {
    title: "owner_sidebar.orders",
    href: "/store/orders",
    icon: ShoppingCart,
  },
  {
    title: "owner_sidebar.contracts",
    href: "/store/contracts",
    icon: FileText,
  },
  {
    title: "pos_order.title",
    href: "/store/pos",
    icon: Utensils,
  },
  {
    title: "owner_sidebar.cart",
    href: "/store/cart",
    icon: ShoppingCart,
  },
  {
    title: "owner_sidebar.bookings",
    href: "/store/bookings",
    icon: CalendarRange,
  },
  {
    title: "owner_sidebar.laundry_orders",
    href: "/store/laundry",
    icon: Waves,
  },
  {
    title: "categories",
    href: "/store/categories",
    icon: Layers,
  },
  {
    title: "admin_sidebar.variant_categories",
    href: "/store/variant-categories",
    icon: Boxes,
  },
  {
    title: "owner_sidebar.products",
    href: "/store/products",
    icon: Package,
  },
  {
    title: "owner_sidebar.product_price_approval",
    href: "/store/price-changes",
    icon: DollarSign,
  },
  {
    title: "owner_sidebar.offers",
    href: "/store/offers",
    icon: Tag,
  },
  {
    title: "owner_sidebar.streaks",
    href: "/store/streaks",
    icon: Award,
  },
  {
    title: "owner_sidebar.Customers_Reviews",
    href: "/store/reviews",
    icon: Star,
  },
  {
    title: "owner_sidebar.tickets",
    href: "/store/tickets",
    icon: Ticket,
  },
  {
    title: "owner_sidebar.Transactions",
    href: "/store/transactions",
    icon: Wallet,
  },
  {
    title: "owner_sidebar.staff",
    href: "/store/staff",
    icon: Users,
  },
  {
    title: "owner_sidebar.booking_services",
    href: "/store/booking-services",
    icon: CalendarRange,
  },
  {
    title: "owner_sidebar.laundry_services",
    href: "/store/laundry-services",
    icon: Waves,
  },

];

export const ownerTopLinks = [
  {
    title: "owner_sidebar.dashboard",
    href: "/owner",
    icon: Home,
  },
];

export const getOwnerSidebarLinks = (provider?: string | null): sidebarLink[] => {
  const baseLinks: sidebarLink[] = [
    {
      title: "owner_sidebar.stores",
      href: "/owner/stores",
      icon: Store,
    },
    {
      title: "owner_sidebar.cart",
      href: "/owner/cart",
      icon: ShoppingCart,
    },
    {
      title: "permissions:create_store",
      href: "/owner/add-store/wizard",
      icon: Plus,
    },
  ];

  if (provider && provider !== "blend") {
    const integrationChildren: sidebarLink[] = [];

    if (provider === "foodics") {
      integrationChildren.push({
        title: "admin_sidebar.foodics",
        href: "/owner/integrations/foodics",
        icon: Network,
      });
    }

    if (provider === "foodizone") {
      integrationChildren.push({
        title: "admin_sidebar.foodizone",
        href: "/owner/integrations/foodizone",
        icon: Network,
      });
    }

    baseLinks.push({
      title: "owner_sidebar.integrations",
      icon: Network,
      children: integrationChildren,
    } as sidebarLink);
  }

  baseLinks.push({
    title: "profile",
    href: "/owner/settings",
    icon: Settings,
  });

  return baseLinks;
};

export const ownerSidebarLinks = [
  {
    title: "owner_sidebar.stores",
    href: "/owner/stores",
    icon: Store,
  },
  {
    title: "owner_sidebar.cart",
    href: "/owner/cart",
    icon: ShoppingCart,
  },
  {
    title: "permissions:create_store",
    href: "/owner/add-store/wizard",
    icon: Plus,
  },
  {
    title: "owner_sidebar.integrations",
    href: "/owner/integrations",
    icon: Network,
  },
  {
    title: "profile",
    href: "/owner/settings",
    icon: Settings,
  },
];

export const OnlyStoreSidebarLinks = [
  {
    title: "profile",
    href: "/store/settings",
    icon: Settings,
  },
];

export const organizerSidebarLinks = [
  {
    title: "admin_sidebar.home",
    href: "/organizer",
    icon: Home,
  },
];

export const organizationSidebarLinks = [
  {
    title: "admin_sidebar.home",
    href: "/organization",
    icon: Home,
  },
  {
    title: "campaigns",
    href: "/organization/campaigns",
    icon: LayoutDashboard,
  },
  {
    title: "donations",
    href: "/organization/donations",
    icon: Heart,
  },
  {
    title: "financials",
    href: "/organization/financials",
    icon: BarChart3,
  },
];
